import axios from 'axios'

// const api_endpoint = 'https://enterprise.api.docmasweetspot.ca'
// const api_endpoint = 'https://staging.enterprise.api.docmasweetspot.ca'
// const api_endpoint = 'http://127.0.0.1:5001'
// const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'


function get_prediction_data(token, payload){
    let api_url = api_endpoint+'/forecasting/prediction';
    return axios_post_call(api_url,payload,token);
}

function create_campaign_plan(token, payload){
    let api_url = api_endpoint+'/forecasting/create_forecasting_reports';
    let forecast_payload = build_forecasting_report_payload(payload);
    return axios_post_call(api_url,forecast_payload,token).then(add_legacy_campaign_plan_data);
}

function create_campaign_plan_folder(token, payload){
    let api_url = api_endpoint+'/forecasting/create_forecasting_reports_folder';
    return axios_post_call(api_url,payload,token).then(add_legacy_campaign_plan_data);
}

function update_campaign_plan(token, payload){
    let api_url = api_endpoint+'/forecasting/edit_forecasting_reports';
    let forecast_payload = build_forecasting_report_update_payload(payload);
    return axios_post_call(api_url,forecast_payload,token).then(add_legacy_campaign_plan_data);
}

function get_campaign_plan(token, payload){
    let api_url = api_endpoint+'/forecasting/get_forecasting_reports';
    return axios_post_call(api_url,payload,token);
}

function delete_campaign_plan(token, payload){
    let api_url = api_endpoint+'/forecasting/delete_forecasting_reports';
    let forecast_payload = build_forecasting_report_id_payload(payload);
    return axios_post_call(api_url,forecast_payload,token).then(add_legacy_campaign_plan_data);
}

function move_reports(token, payload){
    let api_url = api_endpoint+'/forecasting/move_reports';
    return axios_post_call(api_url,payload,token);
}

function delete_campaign_plan_data(token, payload){
    let api_url = api_endpoint+'/forecasting/delete_forecast_data';
    let forecast_payload = build_forecast_data_payload(payload);
    return axios_post_call(api_url,forecast_payload,token).then(add_legacy_campaign_plan_data);
}

function edit_campaign_plan_data(token, payload){
    let api_url = api_endpoint+'/forecasting/edit_forecast_data';
    let forecast_payload = build_forecast_data_payload(payload);
    return axios_post_call(api_url,forecast_payload,token);
}

function get_campaign_plan_data(token, payload){
    let api_url = api_endpoint+'/forecasting/get_forecast_data';
    let forecast_payload = build_forecast_data_payload(payload);
    return axios_post_call(api_url,forecast_payload,token).then(add_legacy_forecast_data);
}


function get_optimization_info(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/info';
    return axios_post_call(api_url, payload, token);
}

function add_new_optimization(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/add';
    return axios_post_call(api_url, payload, token);
}

function add_forecast_set(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/forecast_setup/add';
    return axios_post_call(api_url, payload, token);
}

function copy_optimization(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/copy';
    return axios_post_call(api_url, payload, token);
}

function delete_optimization(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/delete';
    return axios_post_call(api_url, payload, token);
}

function delete_forecast_set(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/forecast_setup/delete';
    return axios_post_call(api_url, payload, token);
}

function update_optimization(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/update';
    return axios_post_call(api_url, payload, token);
}

function get_optimization_data(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/data';
    return axios_post_call(api_url, payload, token);
}

function edit_response_curve(token, payload){
    let api_url = api_endpoint + '/forecasting/optimization/response_curve_edit';
    return axios_post_call(api_url, payload, token)
}

function build_forecasting_report_payload(payload){
    let forecast_payload = Object.assign({}, payload);
    forecast_payload.report_name = payload.report_name || payload.plan_name || 'Forecasting Report';
    forecast_payload.parent_id = payload.parent_id || 0;
    delete forecast_payload.plan_name;
    return forecast_payload;
}

function build_forecasting_report_update_payload(payload){
    if(payload.report_id && payload.update_vals){
        return payload;
    }

    let update_vals = {};
    if(payload.status){
        update_vals.status = payload.status;
    }
    if(payload.stage){
        update_vals.stage = payload.stage;
    }
    if(payload.report_name || payload.plan_name){
        update_vals.report_name = payload.report_name || payload.plan_name;
    }

    return {
        client_id: payload.client_id || String(payload.project_id).slice(0, 4),
        report_id: payload.report_id || payload.plan_id || payload.campaign_plan_id,
        update_vals: update_vals
    };
}

function build_forecasting_report_id_payload(payload){
    return {
        project_id: payload.project_id,
        report_id: payload.report_id || payload.plan_id || payload.campaign_plan_id || payload.folder_id
    };
}

function build_forecast_data_payload(payload){
    let forecast_payload = Object.assign({}, payload);
    forecast_payload.report_id = payload.report_id || payload.plan_id || payload.campaign_plan_id;
    delete forecast_payload.plan_id;
    delete forecast_payload.campaign_plan_id;
    return forecast_payload;
}

function add_legacy_campaign_plan_data(resp){
    if(resp && resp.data && resp.data.report_id && !resp.data.campaign_plan_id){
        resp.data.campaign_plan_id = resp.data.report_id;
    }
    return resp;
}

function add_legacy_forecast_data(resp){
    if(resp && resp.data){
        if(resp.data.forecast_data && !resp.data.plan_data){
            resp.data.plan_data = resp.data.forecast_data;
        }
        if(resp.data.forecasting_report_detail && !resp.data.campaign_detail){
            resp.data.campaign_detail = Object.assign({}, resp.data.forecasting_report_detail, {
                plan_id: resp.data.forecasting_report_detail.report_id
            });
        }
    }
    return resp;
}

/*
Base Caller functions
*/
function axios_post_call(api_url,data,token){
    return new Promise(function(resolve,reject){
        axios.post(api_url, data, {headers: {Authorization: `Bearer ${token}`}}).then((res)=>{
            if(res.status == 200){
                resolve(res.data);
            }
            else{
                reject();
            }
        }).catch((e)=>{
            reject(api_url+e);
        })
    })
}

export default {
    get_prediction_data,
    create_campaign_plan,
    create_campaign_plan_folder,
    update_campaign_plan,
    get_campaign_plan,
    delete_campaign_plan,
    move_reports,
    delete_campaign_plan_data,
    edit_campaign_plan_data,
    get_campaign_plan_data,
    get_optimization_info,
    get_optimization_data,
    add_new_optimization,
    add_forecast_set,
    copy_optimization,
    delete_optimization,
    delete_forecast_set,
    update_optimization,
    edit_response_curve
}
